/**
 * W6 raw-enum legibility (ledger §3.D) — the shared operator-facing note shown after a
 * SITREP / assistance-request forward when the server had no live webhook and instead
 * recorded the attempt to the local delivery log (the `console_log` delivery channel).
 *
 * The dev jargon ("console_log", the `DELIVERY_WEBHOOK_URL` env var) stays in the SERVER
 * log only — it must never surface on an operator toast. Shared by AssistanceRequestDetail
 * + SitrepDetailPanel so the copy stays in ONE place.
 */
export const FORWARDED_LOCALLY_NOTE = 'recorded locally — live delivery not yet configured';
